
import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  Host
} from '@angular/core';
import { TabsetComponent } from '../tabset.component';

@Component({
  selector: 'tab',
  template: `
    <!-- Capture du contenu en template interne -->
    <ng-template><ng-content></ng-content></ng-template>
  `,
  standalone: false
})
export class TabComponent {

  @Input() id!: string;
  @Input() heading!: string;

  @Output() selectTab = new EventEmitter<TabComponent>();
  @Output() deselectTab = new EventEmitter<TabComponent>();

  private _active = false;

  @Input() set active(v: boolean) {
    if (v !== this._active) {
      this._active = v;
      if (v) {
        this.tabset.activateTab(this);
      }
    }
  }
  get active(): boolean {
    return this._active;
  }

  @ViewChild(TemplateRef, { static: true })
  template!: TemplateRef<any>;

  constructor(@Host() public tabset: TabsetComponent) {
    this.tabset.addTab(this);
  }

  activate() {
    if (!this._active) {
      this._active = true;
      this.selectTab.emit(this);
    }
  }

  deactivate() {
    if (this._active) {
      this._active = false;
      this.deselectTab.emit(this);
    }
  }
}